<template>
  <v-container class="relative container1400">
    <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left">
      {{ $t("Cmsg15") }}
    </h2>
    <v-form ref="form" class="pb-5" v-model="valid" lazy-validation>
      <v-card class="pa-7" min-height="500px" v-if="amenitiesList">
        <div v-for="item in amenitiesList" :key="item._id">
          <div class="overline text-left mb-2 pl-3">{{ $t(item._id) }}</div>
          <v-divider class="mb-3"></v-divider>
          <v-row class="pt-4 pb-10">
            <v-col
              cols="auto"
              class="py-0"
              v-for="doc in item.items"
              :key="doc.ln_key"
            >
              <v-checkbox
                class="ma-0 pa-0 subtitle-2"
                dense
                v-model="data.amenities"
                :label="$t(doc.ln_key)"
                :value="doc"
              ></v-checkbox>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-form>
    <div class="text-right mt-10">
      <v-btn
        outlined
        color="grey"
        large
        class="mr-2"
        @click="$emit('goBack')"
        >{{ $t("Back") }}</v-btn
      >
      <v-btn large color="light-blue white--text" rounded @click="next">
        <span class="mr-2">{{ $t("Continue") }}</span>
        <v-icon size="small">mdi-arrow-right-thick</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  props: ["data", "amenitiesList"],
  name: "Step6Component",
  components: {},
  data() {
    return {
      valid: null
    };
  },
  methods: {
    async next() {
      await this.$refs.form.validate();
      if (this.valid) {
        window.scrollTo(0, 0);
        return (this.data.steps = 7);
      }
    }
  }
};
</script>

<style scoped>
.ap-input {
  padding-left: 50px;
}
</style>
